import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
interface PinEntryProps {
  onSuccess: () => void;
}
const CORRECT_PIN = '1234';
export function PinEntry({
  onSuccess
}: PinEntryProps) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const handlePinChange = (value: string) => {
    if (value.length <= 4) {
      setPin(value);
      setError(false);
      if (value.length === 4) {
        if (value === CORRECT_PIN) {
          setTimeout(() => {
            onSuccess();
          }, 300);
        } else {
          setError(true);
          setTimeout(() => {
            setPin('');
            setError(false);
          }, 1000);
        }
      }
    }
  };
  return <div className="min-h-[calc(100vh-140px)] flex items-center justify-center p-4 relative overflow-hidden" data-id="element-915">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" data-id="element-916" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-500/5 rounded-full blur-3xl" data-id="element-917" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-400/3 rounded-full blur-3xl" data-id="element-918" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md relative z-10" data-id="element-919">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="mb-12 text-center" data-id="element-920">
          <img src="https://cdn.magicpatterns.com/uploads/ntWH98XFYLUznrzUUQoeeB/Commissions_Manager_Logo.webp" alt="Rapid Home Lending" className="h-16 mx-auto mb-6 brightness-0 invert" data-id="element-921" />
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-922">
            Commissions Manager
          </h1>
          <p className="text-slate-400 text-sm font-medium" data-id="element-923">
            Enter your PIN to access the dashboard
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-navy-800/70 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/10" data-id="element-924">
          <div className="flex items-center justify-center mb-6" data-id="element-925">
            <div className="p-4 bg-accent-400/10 rounded-full border border-accent-400/20" data-id="element-926">
              <Lock size={32} className="text-accent-400" data-id="element-927" />
            </div>
          </div>

          <div className="mb-6" data-id="element-928">
            <label className="block text-sm font-semibold text-slate-300 mb-3 text-center" data-id="element-929">
              Enter 4-Digit PIN
            </label>
            <input type="password" inputMode="numeric" pattern="[0-9]*" maxLength={4} value={pin} onChange={e => handlePinChange(e.target.value.replace(/\D/g, ''))} className={`w-full text-center text-3xl tracking-[1em] font-bold px-4 py-4 border-2 rounded-xl focus:outline-none transition-colors bg-navy-900/50 text-white ${error ? 'border-red-500/50 bg-red-500/5' : 'border-white/10 focus:border-accent-400/40'}`} placeholder="••••" autoFocus data-id="element-930" />
          </div>

          {error && <motion.p initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center text-sm text-red-400 font-medium" data-id="element-931">
              Incorrect PIN. Please try again.
            </motion.p>}

          <p className="text-center text-xs text-slate-500 mt-4" data-id="element-932">
            Demo PIN: 1234
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="text-center text-sm text-slate-500 font-medium mt-6" data-id="element-933">
          Secure access to your commission data
        </motion.p>
      </motion.div>
    </div>;
}